const base =
  typeof import.meta.env.VITE_LANDING_URL === "string" &&
  import.meta.env.VITE_LANDING_URL.length > 0
    ? (import.meta.env.VITE_LANDING_URL as string).replace(/\/$/, "")
    : "";

/**
 * Base URL of the landing site (no trailing slash). Empty if not configured.
 */
export function getLandingBaseUrl(): string {
  return base;
}

/**
 * Full URL to the Privacy Policy page on the landing site.
 * @param locale - e.g. "es" or "en"
 */
export function getLandingPrivacyUrl(locale: string): string {
  const normalized = locale === "es" || locale === "en" ? locale : "es";
  return base ? `${base}/${normalized}/privacy` : `/${normalized}/privacy`;
}

/**
 * Full URL to the Terms of Use page on the landing site.
 * @param locale - e.g. "es" or "en"
 */
export function getLandingTermsUrl(locale: string): string {
  const normalized = locale === "es" || locale === "en" ? locale : "es";
  return base ? `${base}/${normalized}/terms` : `/${normalized}/terms`;
}

/**
 * Full URL to a published blog post on the landing site.
 * Single-locale ("es") for now — landing routing has localePrefix:"never".
 */
export function getLandingBlogPostUrl(slug: string): string {
  return base ? `${base}/blog/${slug}` : `/blog/${slug}`;
}

/**
 * Full URL to the "How electronic invoicing works" help page on the landing site.
 * @param locale - e.g. "es" or "en"
 */
export function getLandingHelpElectronicInvoicingUrl(locale: string): string {
  const normalized = locale === "es" || locale === "en" ? locale : "es";
  return base
    ? `${base}/${normalized}/help/how-electronic-invoicing-works`
    : `/${normalized}/help/how-electronic-invoicing-works`;
}
